import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M4.29 3.756c2.338-1.658 5.678-1.523 7.84.321 2.198 1.875 2.498 4.94.69 7.133-1.704 2.067-4.776 2.748-7.334 1.682l-.139-.06-2.623.557-.045.008-.066.006-.067-.003-.027-.003-.066-.012-.063-.02-.06-.027-.045-.025-.065-.046-.049-.044-.043-.05-.032-.045-.039-.069-.025-.063-.019-.068-.008-.045L2 12.817l.002-.068.003-.026.012-.066.014-.043.69-2.07-.014-.021c-1.325-2.247-.725-5.032 1.445-6.666z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }